// @flow

import { Skeleton, View } from 'reshaped';

const PLACEHOLDER_ROWS = 4;
type Props = {
  shouldDisplayVATWarning: boolean,
};

export function ContractsPlaceholder({
  shouldDisplayVATWarning,
}: Props): React.MixedElement {
  return (
    <View gap={5} paddingTop={6}>
      <View gap={4} divided>
        {Array.from({ length: PLACEHOLDER_ROWS }, (_, index) => (
          <View key={index} direction="row" gap={2} wrap={false}>
            <Skeleton
              attributes={{
                style: { width: 'var(--rs-checkbox-line-height)' },
              }}
            />
            <View.Item grow>
              <Skeleton width="100%" />
            </View.Item>
          </View>
        ))}
      </View>
      {shouldDisplayVATWarning && <Skeleton width="100%" />}
    </View>
  );
}
